import { createSelector } from 'reselect';
const userStateSelector = (state) => state.user;
export const userActivitiesStateSelector = createSelector(userStateSelector, (user) => user.activities);
// LOAD USER ACTIVITIES
export const loadUserActivitiesSelector = createSelector(userActivitiesStateSelector, (activities) => activities.loadUserActivities);
export const loadUserActivitiesDataSelector = createSelector(loadUserActivitiesSelector, (loadUserActivities) => loadUserActivities.data);
export const loadUserActivitiesMetaDataSelector = createSelector(loadUserActivitiesSelector, (loadUserActivities) => loadUserActivities.metadata);
export const loadUserActivitiesIsLoadingSelector = createSelector(loadUserActivitiesSelector, (loadUserActivities) => loadUserActivities.isLoading);
export const loadUserActivitiesErrorSelector = createSelector(loadUserActivitiesSelector, (loadUserActivities) => loadUserActivities.error);
// REPLAY USER ACTIVITY
export const replayUserActivitySelector = createSelector(userActivitiesStateSelector, (activities) => activities.replayUserActivity);
export const replayedUserActivityIdSelector = createSelector(replayUserActivitySelector, (replayUserActivity) => replayUserActivity.replayedActivityId);
export const replayUserActivityIsLoadingSelector = createSelector(replayUserActivitySelector, (replayUserActivity) => replayUserActivity.isLoading);
export const replayUserActivityErrorSelector = createSelector(replayUserActivitySelector, (replayUserActivity) => replayUserActivity.error);
// CREATE USER ACTIVITY
export const createUserActivitySelector = createSelector(userActivitiesStateSelector, (activities) => activities.createUserActivity);
export const createdUserActivitySelector = createSelector(createUserActivitySelector, (createUserActivity) => createUserActivity.createdActivity);
export const createUserActivityIsLoadingSelector = createSelector(createUserActivitySelector, (createUserActivity) => createUserActivity.isLoading);
export const createUserActivityErrorSelector = createSelector(createUserActivitySelector, (createUserActivity) => createUserActivity.error);
// EDIT USER ACTIVITY
export const editUserActivitySelector = createSelector(userActivitiesStateSelector, (activities) => activities.editUserActivity);
export const editedUserActivityIdSelector = createSelector(editUserActivitySelector, (editUserActivity) => editUserActivity.editedActivityId);
export const editUserActivityIsLoadingSelector = createSelector(editUserActivitySelector, (editUserActivity) => editUserActivity.isLoading);
export const editUserActivityErrorSelector = createSelector(editUserActivitySelector, (editUserActivity) => editUserActivity.error);
// DELETE USER ACTIVITY
export const deleteUserActivitySelector = createSelector(userActivitiesStateSelector, (activities) => activities.deleteUserActivity);
export const deletedUserActivityIdSelector = createSelector(deleteUserActivitySelector, (deleteUserActivity) => deleteUserActivity.deletedActivityId);
export const deleteUserActivityIsLoadingSelector = createSelector(deleteUserActivitySelector, (deleteUserActivity) => deleteUserActivity.isLoading);
export const deleteUserActivityErrorSelector = createSelector(deleteUserActivitySelector, (deleteUserActivity) => deleteUserActivity.error);
export default {
    loadUserActivitiesDataSelector,
    loadUserActivitiesMetaDataSelector,
    loadUserActivitiesIsLoadingSelector,
    loadUserActivitiesErrorSelector,
    replayedUserActivityIdSelector,
    replayUserActivityIsLoadingSelector,
    replayUserActivityErrorSelector,
    createdUserActivitySelector,
    createUserActivityIsLoadingSelector,
    createUserActivityErrorSelector,
    editedUserActivityIdSelector,
    editUserActivityIsLoadingSelector,
    editUserActivityErrorSelector,
    deletedUserActivityIdSelector,
    deleteUserActivityIsLoadingSelector,
    deleteUserActivityErrorSelector,
};
